<template>
  <div class="card-container">
    <el-card style="margin-bottom: 20px">
      <common-el-form
        :model="model1"
        :rules="rules"
        :submitService="submitService1"
        :submitData="submitData1"
        @success="onSuccess"
        :showButton="false"
        :SubmitButton="isSub"
        :preservation="isSub1"
        ref="model1"
      >
        <el-button
          type="primary"
          size="small"
          @click="AddLevelItem"
          style="margin-bottom: 20px"
          >添加
        </el-button>
        <span style="margin-left: 40px; color: #f56c6c"
          >温馨提示：在执行添加操作之后,若确定按钮没有显示,则需要操作人需要把"代理商等级"
          提示"请选择" 的下拉框选择完成之后即可显示</span
        >
        <div
          class="flex-row vertical-center"
          v-for="(item, index) in model1.profitInfo"
          :key="index"
          style="flex-wrap: wrap"
        >
          <div style="display: flex">
            <el-form-item
              label-width="100px"
              label="代理商等级"
              class="flex-row commonMargin"
              :prop="'profitInfo.' + index + '.levelId'"
              :rules="levelId"
            >
              <el-select
                @change="bian()"
                style="width: 150px"
                v-model="item.levelId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in levelNameList"
                  :key="item.id"
                  :label="item.levelName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div style="display: flex">
            <span style="line-height: 38px">(</span>
            <el-form-item
              label-width="100px"
              label="伞下交易量"
              :prop="'profitInfo.' + index + '.tranAmt'"
              class="flex-row commonMargin"
              :rules="tranAmt"
            >
              <el-input-number
                v-model="item.tranAmt"
                controls-position="right"
                :precision="2"
                :step="1"
                :controls="false"
                :min="0"
                style="width: 150px"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
            <span style="line-height: 40px; width: 50px">元</span>
          </div>
          <div style="display: flex">
            <el-form-item
              label-width="52px"
              label="直推"
              :prop="'profitInfo.' + index + '.directNumber'"
              class="flex-row commonMargin"
              :rules="directNumber"
            >
              <el-input-number
                v-model="item.directNumber"
                controls-position="right"
                :controls="false"
                :min="0"
                style="width: 150px"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
            <span style="line-height: 40px; width: 50px">个</span>
          </div>
          <div style="display: flex">
            <el-form-item
              label-width="40px"
              label="等级"
              class="flex-row commonMargin"
              :prop="'profitInfo.' + index + '.directLeveId'"
            >
              <el-select
                style="width: 150px"
                v-model="item.directLeveId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in levelNameList1"
                  :key="item.id"
                  :label="item.levelName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <span style="line-height: 38px; width: 20px">)</span>
          </div>
          <div style="display: flex">
            <el-form-item
              label-width="100px"
              label="团队交易量"
              :prop="'profitInfo.' + index + '.directTranAmt'"
              class="flex-row commonMargin"
              :rules="directTranAmt"
            >
              <el-input-number
                v-model="item.directTranAmt"
                controls-position="right"
                :precision="2"
                :step="1"
                :controls="false"
                :min="0"
                style="width: 150px"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
            <span style="line-height: 40px; width: 50px">元</span>
          </div>
          <el-button
            @click.prevent="RemoveLevelItem(item)"
            style="margin-bottom: 20px"
            v-if="model1.profitInfo.length > 1"
          >
            删除
          </el-button>
        </div>
      </common-el-form>
    </el-card>
  </div>
</template>

<script>
import CommonElForm from "components/common/CommonElForm";
import OrganService from "service/OrganService";
import { loadMixin, dialogMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "upgradeassessment",
  data() {
    return {
      isSub: true,
      isSub1: false,
      submitService1: OrganService.upgradeassessmentSave,
      rules: {},
      levelNameList: [],
      levelNameList1: [
        {
          id: 0,
          levelName: "未选择",
        },
      ],
      model1: {
        profitInfo: [
          {
            levelId: "",
            directNumber: 0,
            directLeveId: 0,
            tranAmt: 0,
            directTranAmt: 0,
          },
        ],
      },
      levelId: {
        required: true,
        validator: (rule, value, callback) => {
          if (!value) {
            return callback(new Error("请选择"));
          }

          const arr = this.model1.profitInfo;
          let index = 0;
          arr.forEach((item) => {
            if (item.levelId == value) {
              index++;
            }
          });
          if (index > 1) {
            return callback(new Error("所选代理商等级不能重复"));
          }
          return callback();
        },
      },
      tranAmt: {
        required: true,
        message: "输入值可以为 0 或其它数值",
      },
      directNumber: {
        required: true,
        message: "输入值可以为 0 或其它数值",
      },
      directTranAmt: {
        required: true,
        message: "输入值可以为 0 或其它数值",
      },
    };
  },
  mixins: [loadMixin, dialogMixin],
  components: {
    CommonElForm,
  },
  created() {},
  mounted() {
    this.getLevelNameList();
    this.getDetail1();
  },
  watch: {
    "model1.profitInfo"(val, oldval) {
      val.forEach((item) => {
        if (item.levelId == "") {
          this.isSub1 = false;
        } else {
          this.isSub1 = true;
        }
      });
    },
  },
  computed: {
    submitData() {
      const params = {};
      return params;
    },
    submitData1() {
      const params = {
        tatId: this.tatId,
        data: JSON.stringify(this.model1.profitInfo),
      };
      return params;
    },
    ...mapGetters(["userId", "orgDetail", "tatId"]),
  },
  methods: {
    getDetail1() {
      this.model1.profitInfo = [];
      this.doLoad(
        OrganService.upgradeassessmentList,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            if (result) {
              for (let i = 0; i < result.length; i++) {
                this.model1.profitInfo.push({
                  levelId: result[i].levelId,
                  directNumber: result[i].directNumber,
                  directLeveId: result[i].directLeveId,
                  tranAmt: result[i].tranAmt,
                  directTranAmt: result[i].directTranAmt,
                });
              }
            } else {
              this.model1.profitInfo.push({
                levelId: "",
                directNumber: 0,
                directLeveId: 0,
                tranAmt: 0,
                directTranAmt: 0,
              });
            }
          });
        },
        "信息获取失败"
      );
    },

    onSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getDetail1();
    },
    AddLevelItem() {
      if (this.model1.profitInfo.length > this.levelNameList.length - 1) {
        this.$alert("已添加全部代理商等级", "提示", {
          confirmButtonText: "确定",
          callback: (action) => {},
        });
        return;
      }
      if (this.model1.profitInfo == null || this.model1.profitInfo == "") {
        this.model1.profitInfo = [];
      }
      this.model1.profitInfo.push({
        levelId: "",
        directNumber: 0,
        directLeveId: 0,
        tranAmt: 0,
        directTranAmt: 0,
      });
    },
    RemoveLevelItem(item) {
      this.showConfirm("确定要删除此等级吗？")
        .then(() => {
          let index = this.model1.profitInfo.indexOf(item);
          if (index !== 0) {
            this.model1.profitInfo.splice(index, 1);
          }
        })
        .catch(() => {});
    },
    getLevelNameList() {
      this.doLoad(
        OrganService.memberupgradeList,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.levelNameList = result.rows;
            this.levelNameList1 = [...this.levelNameList1, ...result.rows];
          });
        },
        "信息获取失败"
      );
    },
    bian() {
      this.model1.profitInfo.forEach((item) => {
        if (item.levelId == "") {
          this.isSub1 = false;
          this.$refs.model1.clearValidate();
        } else {
          this.isSub1 = true;
        }
      });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/UpgradeAssessment.vue